<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in"
  (click)="onClose()">
  <div
    class="relative w-full max-w-4xl bg-white dark:bg-slate-900 rounded-[2rem] shadow-2xl border border-slate-100 dark:border-slate-800 flex flex-col max-h-[92vh] overflow-hidden animate-fade-in-up"
    (click)="$event.stopPropagation()">

    <div *ngIf="isLoading()"
      class="absolute inset-0 bg-white/80 dark:bg-slate-900/80 z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <div class="flex-none px-6 md:px-8 py-5 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between gap-4 bg-white dark:bg-slate-900">
      <div>
        <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">cloud_download</span>
          Preview Taiwan Discount จาก API
        </h3>
        <p class="text-sm text-slate-500 dark:text-slate-400 mt-1 font-medium">
          ตรวจรายการจาก API แล้ว Import หรือ Update เข้าระบบ
        </p>
      </div>
      <button type="button" (click)="onClose()"
        class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="flex-1 overflow-y-auto px-4 md:px-6 py-4 custom-scrollbar bg-white dark:bg-slate-900">
      <div class="overflow-x-auto rounded-2xl border border-slate-200 dark:border-slate-700">
        <table class="w-full text-left border-collapse text-sm">
          <thead class="sticky top-0 z-10 bg-slate-50 dark:bg-slate-800">
            <tr class="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">
              <th class="p-4">UUID</th>
              <th class="p-4">ชื่อ</th>
              <th class="p-4 text-center">Online</th>
              <th class="p-4 text-center">ใน DB</th>
              <th class="p-4 text-center w-[120px]">Action</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-slate-100 dark:divide-slate-800 bg-white dark:bg-slate-900" *ngIf="!isLoading()">
            <tr *ngFor="let row of rows"
              class="hover:bg-amber-50/40 dark:hover:bg-slate-800/60 transition-colors">
              <td class="p-4 font-mono text-xs text-slate-600 dark:text-slate-300 max-w-[180px] truncate" [title]="row.uuid">
                {{ row.uuid }}
              </td>
              <td class="p-4 font-semibold text-slate-700 dark:text-slate-200">{{ row.name || '—' }}</td>
              <td class="p-4 text-center">
                <span class="inline-flex items-center justify-center px-2.5 py-1 rounded-full text-xs font-bold border"
                  [ngClass]="row.isOnline
                    ? 'bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400 border-emerald-200 dark:border-emerald-800'
                    : 'bg-slate-50 dark:bg-slate-800 text-slate-500 dark:text-slate-400 border-slate-200 dark:border-slate-700'">
                  {{ row.isOnline ? 'Online' : 'Offline' }}
                </span>
              </td>
              <td class="p-4 text-center">
                <span class="inline-flex items-center justify-center px-2.5 py-1 rounded-full text-xs font-bold border"
                  [ngClass]="row.existsInDb
                    ? 'bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 border-blue-200 dark:border-blue-800'
                    : 'bg-amber-50 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400 border-amber-200 dark:border-amber-800'">
                  {{ row.existsInDb ? 'มีแล้ว' : 'ใหม่' }}
                </span>
              </td>
              <td class="p-4 text-center">
                <button type="button" (click)="importRow(row)" [disabled]="savingUuid() === row.uuid"
                  class="px-3 py-1.5 rounded-lg bg-amber-400 hover:bg-amber-500 text-white text-xs font-bold shadow-sm shadow-amber-200/50 dark:shadow-none transition-all disabled:opacity-50">
                  {{ savingUuid() === row.uuid ? 'กำลังบันทึก...' : (row.existsInDb ? 'Update' : 'Import') }}
                </button>
              </td>
            </tr>
            <tr *ngIf="rows.length === 0">
              <td colspan="5" class="py-16 text-center">
                <div class="flex flex-col items-center justify-center text-slate-400">
                  <span class="material-icons text-4xl mb-2">cloud_off</span>
                  <p class="font-bold text-slate-700 dark:text-slate-200">ไม่พบข้อมูล preview</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="flex-none px-6 md:px-8 py-5 border-t border-slate-100 dark:border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-3 bg-white dark:bg-slate-900">
      <button type="button" (click)="loadPreview(currentPage - 1)" [disabled]="currentPage <= 1 || isLoading()"
        class="w-full sm:w-auto px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors disabled:opacity-40">
        ก่อนหน้า
      </button>
      <span class="text-sm font-medium text-slate-500 dark:text-slate-400">
        หน้า {{ currentPage }} / {{ totalPages }}
      </span>
      <button type="button" (click)="loadPreview(currentPage + 1)" [disabled]="currentPage >= totalPages || isLoading()"
        class="w-full sm:w-auto px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors disabled:opacity-40">
        ถัดไป
      </button>
    </div>
  </div>
</div>
